import VueI18n from 'vue-i18n'

export default {
  messages: {
    "en": {
      "ok": "OK",
      "Menu": "Menu",
      "lifecycle": "Devices & MQTT approvals",
      "lifecycleNavHint": "Pending devices, claims, MQTT permissions and migration",
      "lifecyclePageDescription": "Pending / unassigned devices, MQTT claims, MQTT permissions and migration candidates in one place. Refresh updates all queues together. All four queues remain visible. Pending can show all projects or only the selected project.",
      "lifecycleAllProjects": "All projects",
      "lifecycleNoProject": "No project",
      "lifecyclePendingTab": "Pending / Unassigned",
      "lifecycleClaimsTab": "MQTT Claims",
      "lifecycleMigrationTab": "Migration Candidates",
      "lifecyclePermissionsTab": "MQTT Permissions",
      "lifecyclePermissionsPending": "MQTT Permissions Pending",
      "lifecyclePermissionsHintTitle": "Approve MQTT permissions",
      "lifecyclePermissionsHint": "Review pending MQTT access requests. Active grants and history are available here as well.",
      "lifecyclePendingHintTitle": "Assign and approve devices",
      "lifecyclePendingHint": "Review newly discovered or unassigned devices and move them into the regular location flow.",
      "lifecycleClaimsHintTitle": "Review MQTT claims",
      "lifecycleClaimsHint": "Check new MQTT claims, assign a target location and decide whether to approve, reject or block them.",
      "lifecycleMigrationHintTitle": "Control migration steps",
      "lifecycleMigrationHint": "Use this area to verify legacy ESP devices and trigger the next MQTT migration step when they are ready.",
      "lifecycleClaimPendingHint": "Pending claims need review data such as name, location and optional config before approval.",
      "lifecycleClaimApprovedHint": "Approved claims show devices that were already provisioned into a project.",
      "lifecycleClaimHistoryHint": "History keeps rejected and blocked claims visible for later review.",
      "lifecycleLocationSummaryHint": "Pending devices, MQTT claims and migration candidates were moved to the central lifecycle page.",
      "openLifecycle": "Open Device Lifecycle",
      "Display": "Display",
      "Smoothed": "Smoothed",
      "Unsmoothed": "Unsmoothed",
      "Project": "Project"
    },
    "de": {
      "ok": "OK",
      "Menu": "Menü",
      "person": "Person",
      "Persons": "Personen",
      "energyUnit": "Energieerzeuger",
      "location": "Location",
      "contract": "Vertrag",
      "Dashboard": "Dashboard",
      "device": "Geräte",
      "lifecycle": "Geräte & MQTT-Freigaben",
      "lifecycleNavHint": "Pending-Geräte, Claims, MQTT-Berechtigungen und Migration",
      "lifecyclePageDescription": "Pending / Unassigned, MQTT Claims, MQTT-Berechtigungen und Migrationen auf einen Blick. Refresh aktualisiert alle Queues gemeinsam. Alle vier Bereiche bleiben sichtbar. Pending zeigt wahlweise alle Projekte oder nur das gewählte Projekt.",
      "lifecycleAllProjects": "Alle Projekte",
      "lifecycleNoProject": "Kein Projekt",
      "lifecyclePendingTab": "Pending / Unassigned",
      "lifecycleClaimsTab": "MQTT Claims",
      "lifecycleMigrationTab": "Migration Candidates",
      "lifecyclePermissionsTab": "MQTT-Berechtigungen",
      "lifecyclePermissionsPending": "MQTT-Berechtigungen Pending",
      "lifecyclePermissionsHintTitle": "MQTT-Berechtigungen freigeben",
      "lifecyclePermissionsHint": "Offene MQTT-Zugriffsanfragen prüfen und freigeben. Aktive Berechtigungen und Historie sind hier ebenfalls verfügbar.",
      "lifecyclePendingHintTitle": "Geräte zuordnen und freigeben",
      "lifecyclePendingHint": "Neue oder noch nicht zugewiesene Geräte einer Location zuordnen und in den regulären Gerätefluss übernehmen.",
      "lifecycleClaimsHintTitle": "MQTT-Claims prüfen",
      "lifecycleClaimsHint": "Neue MQTT-Claims sichten, einer Location zuweisen und dann freigeben, ablehnen oder blockieren.",
      "lifecycleMigrationHintTitle": "Migration steuern",
      "lifecycleMigrationHint": "Bestehende ESP-Geräte prüfen und die nächsten MQTT-Migrationsschritte nur dann anstoßen, wenn der Status dazu passt.",
      "lifecycleClaimPendingHint": "Offene Claims brauchen vor der Freigabe mindestens Name, Location und optional Konfigurationsdaten.",
      "lifecycleClaimApprovedHint": "Hier siehst du bereits freigegebene Claims, die einem Projekt zugeordnet wurden.",
      "lifecycleClaimHistoryHint": "History zeigt abgelehnte und blockierte Claims für Nachverfolgung und spätere Prüfung.",
      "lifecycleLocationSummaryHint": "Pending / Unassigned, MQTT Claims und Migration Candidates wurden auf die zentrale Lifecycle-Seite verschoben.",
      "openLifecycle": "Zum Geräte-Lifecycle",
      "admin": "Admin",
      "home": "Home",
      "administration": "Administration",
      "Sign Up": "Registrieren",
      "Forgot password?": "Passwort vergessen?",
      "You don't have an account yet and you want to sign up?": "Sie haben noch keinen User Zugang und wollen sich registrieren?",
      "Back to Login": "Zurück zum Login",
      "invoice": "Rechnung",
      "Reset password": "Passwort zurücksetzen",
      "Logout": "Abmelden",
      "Set New Password": "Neues Passwort festlegen",
      "Password reset error": "Fehler im Rücksetzen des Passwortes",
      "New Password successfully set": "Neues Passwort wurde erfolgreich gesetzt",
      "Account activated": "Account aktiviert",
      "You can now log in with your account.": "Sie können sich jetzt mit Ihrem Account anmelden.",
      "Account activation error": "Aktivierung des Accounts fehlgeschlagen",
      "Your request for password change successfully submitted.": "Ihre Anfrage zur Passwortänderung wurde erfolgreich übermittelt.",
      "Something went wrong": "Ein Fehler ist aufgetreten",
      "Password change": "Passwort ändern",
      "Your password has been changed": "Ihr Passwort wurde geändert",
      "Please check your e-mail.": "Bitte überprüfen Sie Ihren email Account",
      "user": "User",
      "login": "Anmelden",
      "Repeat": "Vorgang wiederholen",
      "Connecting to Services": "Verbindungsaufbau zu Diensten",
      "Setup Device": "Gerät einrichten",
      "Number": "Nummer",
      "FeedIn": "Einspeisung",
      "ProductionPV": "Produktion",
      "Consumption": "Bezug",
      "Year": "Jahr",
      "Month": "Monat",
      "Day": "Tag",
      "production actual month": "Einspeisung aktueller Monat",
      "consumption actual month": "Strombezug aktueller Monat",
      "actual production": "Aktuelle Einspeisung",
      "actual consumption": "Aktueller Strombezug",
      "meter reading production": "Zählerstand Einspeisung",
      "meter reading consumption": "Zählerstand Bezug",
      "Home": "Home",
      "Display Name": "Angezeigter Name",
      "Log In": "Anmelden",
      "The email already exists": "Fehler - Die Email Adresse existiert bereits!",
      "Act Consumption": "Akt. Bezug",
      "Act Production": "Akt.Produktion",
      "Act Feed-In": "Akt.Einspeisung",
      "day": "Tag",
      "month": "Monat",
      "year": "Jahr",
      "User": "User",
      "Skip": "Überspr.",
      "Save": "Speichern",
      "Change Password": "Passwort ändern",
      "Production": "Produktion",
      "Solar": "Solar",
      "Pricing": "Pricing",
      "Display": "Darstellung",
      "Smoothed": "Geglättet",
      "Unsmoothed": "Ungeglättet",
      "Project": "Projekt"
    }
  }
}
